import React from "react";
import styled from "styled-components";
import { Section, Container, H2, CenteredHead } from "../components/ui";

// Native <details>: keyboard accessible, zero JavaScript
const List = styled.div`
  max-width: 760px;
  margin: 0 auto;
  border-top: 1px solid var(--line);
`;

const Item = styled.details`
  border-bottom: 1px solid var(--line);
  font-family: var(--fontR);

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 1.375rem 0.25rem;
    font-family: var(--fontL);
    font-size: 1.125rem;
    font-weight: 500;
    letter-spacing: -0.01em;
    cursor: pointer;
    list-style: none;
  }

  summary::-webkit-details-marker {
    display: none;
  }

  summary::after {
    content: "+";
    flex-shrink: 0;
    font-family: var(--fontR);
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 1;
    color: var(--text-lo);
    transition: transform 150ms ease;
  }

  &[open] summary::after {
    transform: rotate(45deg);
  }

  summary:focus-visible {
    outline: 2px solid var(--green);
    outline-offset: 2px;
    border-radius: 8px;
  }

  p {
    padding: 0 2.5rem 1.5rem 0.25rem;
    font-size: 1rem;
    line-height: 1.6;
    color: var(--text-lo);
    max-width: 62ch;
  }

  a {
    color: var(--text-hi);
    text-underline-offset: 3px;
  }
`;

const QUESTIONS = [
  {
    q: "Mes données bancaires sont-elles en sécurité ?",
    a: "La connexion passe par Powens, un prestataire d'agrégation bancaire agréé et régulé. L'accès est en lecture seule : Nea voit tes opérations, elle ne peut pas faire de virement. Tes données sont chiffrées et ne sont jamais revendues.",
  },
  {
    q: "C'est vraiment gratuit ?",
    a: "Oui. Pendant l'offre de lancement, toute l'app est gratuite, sans abonnement. Si ça devait changer un jour, tu serais prévenu avant.",
  },
  {
    q: "Est-ce que je dois tout saisir à la main ?",
    a: "Non. Tes opérations arrivent et se classent automatiquement. Tu corriges une catégorie une fois, Nea retient.",
  },
  {
    q: "Je n'y connais rien en investissement. C'est pour moi ?",
    a: "Oui, c'est même pour toi en premier. Nea commence par ta sécurité financière, pas par des produits. Et tu peux poser n'importe quelle question au copilote, sans jargon et sans avoir l'air bête.",
  },
  {
    q: "Quelles banques sont compatibles ?",
    a: (
      <>
        Powens couvre la grande majorité des banques en Belgique, au Luxembourg et en France. Si la tienne manque,{" "}
        <a href="mailto:support@nea.lu">écris-nous</a>, on regarde.
      </>
    ),
  },
  {
    q: "Et sur Android ?",
    a: (
      <>
        L'app est disponible sur iPhone. La version Android arrive : <a href="#android">laisse ton email</a>, on te
        prévient le jour de la sortie.
      </>
    ),
  },
];

const Faq = () => (
  <Section id="faq" style={{ paddingTop: "5rem", paddingBottom: "5rem" }}>
    <Container>
      <CenteredHead data-reveal>
        <H2>Questions fréquentes</H2>
      </CenteredHead>
      <List>
        {QUESTIONS.map((item) => (
          <Item key={item.q}>
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </Item>
        ))}
      </List>
    </Container>
  </Section>
);

export default Faq;
